import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Candidate } from "@/types/candidate";
import { EditCandidateFormFields } from "./EditCandidateFormFields";
import { useEditCandidateForm } from "@/hooks/candidate/useEditCandidateForm";
import { useTranslation } from "react-i18next";

interface EditCandidateModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSave: (updatedCandidate: Partial<Candidate>) => Promise<void>;
	candidate: Candidate;
}

export const EditCandidateModal = ({ 
	isOpen, 
	onClose, 
	onSave, 
	candidate 
}: EditCandidateModalProps) => {
	const { t } = useTranslation();
	const {
		formData,
		isSubmitting,
		handleChange,
		handleStatusChange,
		handleSkillsChange,
		handleSubmit
	} = useEditCandidateForm(candidate, async (data) => {
		try {
			// Ensure we're passing all changes to be saved
			console.log("Saving candidate changes:", data);
			await onSave(data);
			// Success - the modal will be closed by the parent component
		} catch (error) {
			console.error("Error saving candidate:", error);
		}
	});

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="w-full max-w-4xl">
				<DialogHeader>
					<DialogTitle>{t("candidates.actions.edit")}</DialogTitle>
				</DialogHeader>
				<form onSubmit={handleSubmit} className="space-y-4 py-4 max-h-[75vh] overflow-y-auto">
					<EditCandidateFormFields
						formData={formData}
						handleChange={handleChange}
						handleStatusChange={handleStatusChange}
						handleSkillsChange={handleSkillsChange}
					/>
					
					<div className="flex justify-end gap-2 pt-4">
						<Button variant="outline" type="button" onClick={onClose} disabled={isSubmitting}>
							{t("common.cancel")}
						</Button>
						<Button type="submit" disabled={isSubmitting}>
							{isSubmitting ? t("common.loading") : t("common.save")}
						</Button>
					</div>
				</form>
			</DialogContent>
		</Dialog>
	);
};
